import React, { Component } from "react";

class NoMatch extends Component {
  state = {};

  componentDidMount() {
    document.title = "Oops! This page does not exist";
  }
  render() {
    return (
      <React.Fragment>
        <h1
          style={{
            textAlign: "center",
            color: "#525252",
            marginTop: 100 + "px"
          }}
        >
          Oops! This page does not exist,
        </h1>
        <h1 style={{ textAlign: "center", color: "#525252" }}>
          check your url
        </h1>
      </React.Fragment>
    );
  }
}

export default NoMatch;
